import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfigService } from './app-config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class LocalloopsService {
  OBPortalSvcURL = '';
  
constructor(
  private appConfigService: AppConfigService,
  private httpClient: HttpClient, 
) { }

public getLocalLoops (evtcode: string | undefined): Observable<any> {
  this.OBPortalSvcURL = this.appConfigService.OBPortalSvcURL;
   const LocalloopsInfo: JSON = <JSON>(<unknown>{
    evtcode: evtcode
   });
   const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
   return this.httpClient.post<any>(
     this.OBPortalSvcURL + 'GetLocalLoops',
     JSON.stringify(LocalloopsInfo),
     { headers: headers }
   );
 }

}